function shareProduct() {
  const productUrl = window.location.href;
  const productTitle = document.querySelector('h1')?.innerText || document.title;

  if (navigator.share) {
    navigator.share({
      title: productTitle,
      url: productUrl
    });
  } else {
    navigator.clipboard.writeText(productUrl);
    alert("Product link copied!");
  }
}